import { RemoteTypes } from '../../../data/usecases/types/types'
import { makeAxiosHttpClient } from '../../factories/http/axios-http-client-factory-no-redirect'

export const makeRemoteType = ():any => new RemoteTypes('/tipo', makeAxiosHttpClient())

export const makeRemoteTypeAll = ():any => new RemoteTypes('/tipo/all', makeAxiosHttpClient())

export const makeRemoteTypeAllPaged = ():any => new RemoteTypes('/tipo/all/paged', makeAxiosHttpClient())
